import React from "react";
import { ListItem, isActive, onClick } from "./OptionsList";
import { categoryToCategoryName } from "./FilterItems";
import { JAPIAutoCompleteLoader } from "../../../latestResearch/publications/JAPIAutoCompleteLoader";

export const AutoCompleteList = ({ keyword, language, category, acFilter, filter = {}, ...props }) => (
  <JAPIAutoCompleteLoader
    {...props}
    keyword={keyword}
    language={language}
    category={category}
    render={(suggestions) =>
      suggestions
        .filter((suggestion) => suggestion.CategoryName === (acFilter || categoryToCategoryName[category] || category))
        .map((suggestion) => ({ name: suggestion.CategoryValue, lang: suggestion.CategoryLang }))
        .map((option, key) => (
          <ListItem
            key={key}
            label={option.name}
            category={
              (categoryToCategoryName[category] || category) + (option.lang && option.lang === "ja" ? "-JA" : "")
            }
            filter={filter}
            isActive={isActive({
              filter,
              category:
                (categoryToCategoryName[category] || category) + (option.lang && option.lang === "ja" ? "-JA" : ""),
              option: option.name,
            })}
            onClick={() =>
              onClick({
                filter,
                category:
                  (categoryToCategoryName[category] || category) + (option.lang && option.lang === "ja" ? "-JA" : ""),
                option: option.name,
              })
            }
          ></ListItem>
        ))
    }
  />
);
